/**
 * The surface pattern presets (STYLE §15). A vertex carries its preset in aMeta.z as patternCode(id);
 * patterns.glsl reads it back and looks the preset's parameters up in uPatternData. A preset is
 * added here only with sourced values in presets.ts.
 */
export const PATTERN = {
  none: 0,
  houseBrick1538: 1,
  timberFront1538: 2,
  roofTileHollePan: 3,
  slateMaas: 4,
  brickOudeKerkTower: 5,
  brickLateGothic: 6,
  brickLateGothicSpeklagen: 7,
  leadSheet: 8,
  leadedGlass: 9,
  hullCarvel: 10,
  hullClinker: 11,
  sailcloth: 12,
  quayPiling: 13,
  streetPaving: 14,
  brickLateGothicGobertange: 15,
  brickLateGothicLedesteen: 16,
  sandstoneAshlar: 17,
} as const;

export type PatternId = (typeof PATTERN)[keyof typeof PATTERN];

/** The presets with none, which is the number of rows of the uniform table. */
export const PATTERN_COUNT = Object.keys(PATTERN).length;

/* A preset rides half-way between whole numbers and anything below 1.25 reads as none: ships still
   write stroke seeds in [0, 1] into aMeta.z, and a seed that rounds to 1 would otherwise read as
   preset 1. Interpolation moves a constant attribute by far less than the quarter either side. */
export const PATTERN_CODE_FLOOR = 1.25;

/* Ids reach the builder from typed code, but an id outside the table would have the shader read past
   uPatternData, so one is refused where it is written rather than drawn as another preset's data. */
export function patternCode(id: PatternId): number {
  if (!Number.isInteger(id) || id < PATTERN.none || id >= PATTERN_COUNT) {
    throw new RangeError(`No pattern preset has the id ${id}`);
  }
  return id === PATTERN.none ? 0 : id + 0.5;
}

export function patternOfCode(code: number): number {
  return code >= PATTERN_CODE_FLOOR && code < PATTERN_COUNT ? Math.trunc(code) : PATTERN.none;
}
